import './unapplied_filter_view.js.coffee'
Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.ToggleableUnappliedFilterView extends Common.Dashboard.Filters.UnappliedFilterView
  template: JST['backbone/templates/common/dashboard/filters/unapplied/toggleable_unapplied_filter']
  className: 'unapplied-filter closed-filter'

  events:
    'click .filter-header': 'toggleOpenFilter'
    'click .filter-apply': 'applyFilter'

  toggleOpenFilter: ->
    @$el.toggleClass 'closed-filter'
    @$('.filter-arrow').toggleClass 'icon-chevron-down icon-chevron-right'

  _toogleApplyButton: =>
    disabled = @_getSelectedValues().length == 0
    @_acceptButton().prop('disabled', disabled)

  _acceptButton: ->
    @$el.find('.filter-apply')
